import React from "react";
import Wrapper from "@/components/shared/Wrapper";

const ICON_GRADIENT = "linear-gradient(180deg, #076698 0%, #E1E9F7 214.29%)";

const DashboardKpiCard = ({ value, label, icon: Icon }) => (
  <Wrapper className="!flex-row items-center gap-3 px-5 py-4">
    <div
      className="flex items-center justify-center rounded-[12px] shrink-0"
      style={{ background: ICON_GRADIENT, width: 39, height: 39, padding: 9 }}
    >
      <Icon size={20} color="#fff" />
    </div>
    <div className="flex flex-col gap-0.5">
      <p
        className="font-semibold leading-tight"
        style={{ fontFamily: "Poppins, sans-serif", fontSize: 28, letterSpacing: "-0.03em", color: "#333333" }}
      >
        {value ?? "—"}
      </p>
      <p
        className="font-medium leading-tight"
        style={{ fontFamily: "Poppins, sans-serif", fontSize: 14, color: "#909FBA" }}
      >
        {label}
      </p>
    </div>
  </Wrapper>
);

export default DashboardKpiCard;
